import { forwardRef } from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export const LinkBehavior = forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;
  return (
    <RouterLink
      data-testid="custom-link"
      ref={ref}
      to={href}
      {...other}
      className={twMerge(
        'text-primaryBlue hover:text-spartanBlue active:text-plumBlue',
        other.className,
      )}
    />
  );
});

LinkBehavior.displayName = 'LinkBehavior';
